<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <!-- <vx-card class="mb-2">
      <div class="vx-row mb-2">
        <div class="vx-col w-full ml-5">
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-2/12 flex-inline">
              <span>فیلتر:</span>
            </div>
            <div class="vx-col sm:w-8/12 flex-inline">
              <vs-input v-model="filter" class="w-full" />
            </div>
          </div>
        </div>
        <div class="vx-col w-full ml-5">
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-2/12 flex-inline">
              <span>مجوز:</span>
            </div>
            <div class="vx-col sm:w-8/12 flex-inline">
              <v-select class="selectExample w-full" v-model="permission" :options="permissions"></v-select>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col">
          <vs-button @click="clear" class="mx-3" color="primary" type="border">پاک کردن</vs-button>
        </div>
        <div class="vx-col">
          <vs-button
            @click="pageNo=1;fillTable(false)"
            class="mx-3"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
          >جستجو</vs-button>
        </div>
      </div>
    </vx-card> -->

    <vx-card class="mb-2">
      <vs-table
        id="tbl1"
        ref="tbl1"
        :data="roles2"
        class="table-dark-inverted"
        @selected="selected"
        :max-items="pageSize"
        :currentPage="pageNo"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">
                          {{ (pageNo-1)*pageSize +1}}
                          -
                          {{ (pageNo)*pageSize>totalCount?totalCount:(pageNo)*pageSize }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                      </div>
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col sm:w-1/3 flex-inline">
              <vs-button
                style="float: left;"
                @click="new_()"
                class="mx-3"
                color="dark"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
              >تیکت جدید</vs-button>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th>عنوان</vs-th>
          <vs-th>متن</vs-th>
          <vs-th>دپارتمان</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{tr.subject}}</span>
              <vs-chip class="number inline-flex float-none pt-1" color="primary">{{ 1 }}</vs-chip>
            </vs-td>
            <vs-td>
              <span>{{tr.message}}</span>
            </vs-td>
            <vs-td>
              <span>{{tr.departmentName}}</span>
            </vs-td>            
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <!-- <create-or-edit-ticket ref="createOrEditRole1" @success="fillTable()"></create-or-edit-ticket> -->
  </div>
</template>
<style>
.nav-transacttions > .vs-popup {
  width: 100%;
}
</style>
<script>
import vSelect from "vue-select";
import { MerchantStatus, Colors } from "@/enums.js";
// import CreateOrEditTicket from "./CreateOrEditTicket";
export default {
  props: {
    transactions: {}
  },
  components: {
    "v-select": vSelect,
    // CreateOrEditTicket
  },
  data() {
    return {
      roles2: [],
      Colors,
      totalCount: 1,
      pageSize: 9999,
      pagesCount: 1,
      pageNo: 1,
      selectedUserId: null,
      filter: "",
      permission: ""
    };
  },
  computed: {},
  methods: {
    fillTable() {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          MaxResultCount: this.pageSize,
          SkipCount: this.pageSize * (this.pageNo - 1),
          Permission: this.permission == null ? null : this.permission.value,
          Filter: this.filter
        }
      };
      this.$http
        .get("/api/services/app/Support/GetAll", payload)
        .then(response => {
          this.roles2 = response.data.result;
          this.$vs.loading.close();
          this.totalCount = this.roles2.length;
        }) //end success
        .catch(error => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    clear() {
      this.permission = "";
      this.filter = "";
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
    },
    new_() {
      //this.$refs.createOrEditRole1.show();
      this.$router.push({
        name: "CreateTicket"
        // params: {
        //   title: 'تیکت جدید'
        // }
      });
    },
    edit(userId, shopName) {
      this.$refs.createOrEditRole1.show(userId, shopName);
    },
    confirmDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `تاییدیه حذف`,
        text: `آیا از حذف ‌کارمزد "${name}" مطمئن هستید؟`,
        accept: () => {
          this.delete_(id);
        },
        acceptText: "تایید",
        cancelText: "انصراف"
      });
    },
    delete_(id) {
      let loading = this.$vs.loading();
      let payload = {
        params: {
          id: id
        }
      };
      this.$http
        .delete("/api/services/app/Role/DeleteRole", payload)
        .then(response => {
          if (response.data.success == true) {
            this.fillTable();
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "کارمزد با موفقیت حذف شد"
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    selected(tr) {
      this.$router.push({
        name: "TicketItems",
        query: {
          id: tr.id
        }
      });
    },
  },
  mounted() {
    this.fillTable();
  }
};
</script>
